import { css, cx } from "@emotion/css";

import { ProgressCircle } from "@/modules/theme/components/ProgressCircle/ProgressCircle";
import { blue, grey } from "@/modules/theme/utils/colors";

import { LevelNumber } from "./helpers/LevelNumber";
import { pickLevelIcon } from "./helpers/pickLevelIcon";

type LevelProgressProps = {
  level: number;
  progress: number;
  active?: boolean;
  done?: boolean;
  className?: string;
};

export const LevelProgress: React.FC<LevelProgressProps> = ({
  level,
  progress,
  active = false,
  done = false,
  className,
}) => {
  const classes = createLevelProgressStyles();
  const LevelIcon = pickLevelIcon(level);

  return (
    <div className={cx(classes.root, className)}>
      <ProgressCircle
        size={116}
        progress={progress}
        strokeWidth={6}
        childrenClassName={cx(
          done ? classes.done : classes.notDone,
          classes.icon
        )}
      >
        <LevelIcon className={classes.icon} />
        <LevelNumber level={level} active={active} />
      </ProgressCircle>
    </div>
  );
};

function createLevelProgressStyles() {
  return {
    root: css({
      display: "grid",
      placeItems: "center",
      position: "relative",
    }),
    icon: css({
      maxHeight: 94,
    }),

    done: css({
      color: blue[350],
    }),
    notDone: css({
      color: grey[100],
    }),
  };
}
